import {on} from 'delegated-events'

function setHiddenFieldsForChosenPayout(form: Element, payoutEl: Element) {
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const stripeIDField = form.querySelector<HTMLInputElement>('.js-sponsors-stripe-id')!
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const payoutStartDateUnixField = form.querySelector<HTMLInputElement>('.js-sponsors-payout-start-date-unix')!

  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const stripeID = payoutEl.getAttribute('data-stripe-account-id')!
  stripeIDField.value = stripeID

  const payoutStartDateUnix = payoutEl.getAttribute('data-payout-start-date-unix')
  if (payoutStartDateUnix) {
    payoutStartDateUnixField.value = payoutStartDateUnix
  } else {
    payoutStartDateUnixField.value = ''
  }
}

function updatePayoutMenuText(form: Element, text: string) {
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const chosenPayoutEl = form.querySelector('.js-sponsors-chosen-payout')!
  const labelEl = chosenPayoutEl.querySelector('.Button-label')
  if (labelEl) {
    labelEl.textContent = text
  } else {
    chosenPayoutEl.textContent = text
  }
}

function enableSubmitButton(form: Element) {
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const submitButton = form.querySelector<HTMLButtonElement>('.js-sponsors-generate-receipt-button')!
  if (submitButton.disabled) submitButton.disabled = false
}

function clearActiveItems(form: Element, selector: string) {
  const items = form.querySelectorAll<HTMLElement>(selector)
  for (const item of items) {
    item.setAttribute('aria-checked', 'false')
    const li = item.closest('li')
    if (li) {
      li.classList.remove('ActionListItem--navActive')
    }
  }
}

function setActiveItem(button: HTMLElement) {
  button.setAttribute('aria-checked', 'true')
  const li = button.closest('li')
  if (li) {
    li.classList.add('ActionListItem--navActive')
  }
}

function closeOverlay(form: Element) {
  const overlay = form.querySelector<HTMLElement>('.js-sponsors-payout-overlay')
  if (overlay) {
    overlay.hidePopover()
  }
}

on('click', '.js-sponsors-stripe-payout-item', ({currentTarget}) => {
  const form = currentTarget.closest('.js-sponsors-payout-receipt-form')
  if (!form) return

  const button = currentTarget as HTMLElement
  const payoutId = button.getAttribute('data-payout-id')
  const payoutText = button.getAttribute('data-payout-text')
  if (!payoutId || !payoutText) return

  clearActiveItems(form, '.js-sponsors-payout-year-item')
  const payoutYearField = form.querySelector<HTMLInputElement>('input[name="payout_year"]')
  if (payoutYearField) payoutYearField.value = ''

  const payoutIdField = form.querySelector<HTMLInputElement>('input[name="payout_id"]')
  if (payoutIdField) payoutIdField.value = payoutId

  setHiddenFieldsForChosenPayout(form, button)

  clearActiveItems(form, '.js-sponsors-stripe-payout-item')
  setActiveItem(button)
  updatePayoutMenuText(form, payoutText)
  enableSubmitButton(form)
  closeOverlay(form)
})

on('click', '.js-sponsors-payout-year-item', ({currentTarget}) => {
  const form = currentTarget.closest('.js-sponsors-payout-receipt-form')
  if (!form) return

  const button = currentTarget as HTMLElement
  const payoutYear = button.getAttribute('data-payout-year') || ''
  const payoutText = button.getAttribute('data-payout-text') || ''

  clearActiveItems(form, '.js-sponsors-stripe-payout-item')
  const payoutIdField = form.querySelector<HTMLInputElement>('input[name="payout_id"]')
  if (payoutIdField) payoutIdField.value = ''
  const stripeIDField = form.querySelector<HTMLInputElement>('.js-sponsors-stripe-id')
  if (stripeIDField) stripeIDField.value = ''
  const startDateField = form.querySelector<HTMLInputElement>('.js-sponsors-payout-start-date-unix')
  if (startDateField) startDateField.value = ''

  const payoutYearField = form.querySelector<HTMLInputElement>('input[name="payout_year"]')
  if (payoutYearField) payoutYearField.value = payoutYear

  clearActiveItems(form, '.js-sponsors-payout-year-item')
  setActiveItem(button)
  updatePayoutMenuText(form, payoutText)
  enableSubmitButton(form)
  closeOverlay(form)
})
